import { FormValues } from "./types";

export const INITIAL_VALUES: FormValues = {
  hasSubscriptionUrl: "yes",
  prospectIdOrSubscriptionUrl: "",
  accountType: null,
  client: null,
  entity: null,
  entityType: "",
  amlEntityType: "",
  entityName: "",
  assignToMyself: false,
  dateOfBirth: undefined,
  streetLine1: "",
  streetLine2: "",
  city: "",
  stateOrProvince: "",
  country: "",
  zipCode: "",
  taxIdType: undefined,
  taxId: "",
  phoneNumber: "",
  emailAddress: "",
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfFormation: undefined,
  programName: undefined,
};

// Key mappings of extracted data from query and form values
export const FIELD_MAPPING: Partial<Record<keyof FormValues, string>> = {
  firstName: "first_name",
  middleName: "middle_name",
  lastName: "last_name",
  entityName: "legal_name",
  dateOfBirth: "date_of_birth",
  dateOfFormation: "date_of_organization",
  streetLine1: "street",
  streetLine2: "street2",
  city: "city",
  stateOrProvince: "state",
  country: "country",
  zipCode: "postal_code",
};
